/* LoveinTea PDP (lit-pdp) */
(function () {
  if (window.__litPdp) return;
  window.__litPdp = true;

  function fmtMoney(cents, format) {
    cents = Math.round(cents);
    var f = format || '${{amount}}';
    function grp(n, d, t, s) {
      var p = (n / 100).toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p.join(d ? s : '');
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return grp(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(cents, 0, '.', ',');
      return grp(cents, 2, ',', '.');
    });
  }

  function init(root) {
    if (!root || root.__lit) return;
    root.__lit = true;
    var cfg = {}, variants = [];
    var cfgEl = root.querySelector('[data-lit-config]'), varEl = root.querySelector('[data-lit-variants]');
    try { if (cfgEl) cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    try { if (varEl) variants = JSON.parse(varEl.textContent); } catch (e) {}
    var L = cfg.labels || {};
    var money = function (c) { return fmtMoney(c, cfg.moneyFormat); };

    var form = root.querySelector('form.lit-form');
    var idInput = root.querySelector('[data-lit-id]');
    var planInput = root.querySelector('[data-lit-plan]');
    var cta = root.querySelector('[data-lit-cta]');
    var packs = [].slice.call(root.querySelectorAll('.lit-pack'));
    var modes = [].slice.call(root.querySelectorAll('.lit-mode'));
    var cads = [].slice.call(root.querySelectorAll('.lit-cad__btn'));
    var cadBox = root.querySelector('[data-lit-cad]');
    var subBadge = root.querySelector('[data-lit-sub-badge]');

    var state = {
      vid: idInput ? Number(idInput.value) : null,
      sub: !!(cfg.hasPlans && cfg.subDefault),
      plan: cads.length ? Number(cads[0].dataset.plan) : null
    };

    function variant(id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return null; }
    function alloc(v) {
      if (!v || !state.plan || !v.selling_plan_allocations) return null;
      for (var i = 0; i < v.selling_plan_allocations.length; i++) if (v.selling_plan_allocations[i].selling_plan_id === state.plan) return v.selling_plan_allocations[i];
      return null;
    }
    function priceOf(v) { var a = state.sub ? alloc(v) : null; return a ? a.price : v.price; }

    function setRadio(list, el) {
      list.forEach(function (b) {
        var on = b === el;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        if (b.hasAttribute('tabindex')) b.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    function render() {
      var v = variant(state.vid);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (planInput) {
        var a = alloc(v);
        planInput.disabled = !(state.sub && a);
        planInput.value = state.sub && a ? state.plan : '';
      }
      packs.forEach(function (b) {
        var pv = variant(Number(b.dataset.variant));
        if (!pv) return;
        var units = Number(b.dataset.units) || 0;
        var p = priceOf(pv);
        var pe = b.querySelector('[data-lit-pack-price]');
        var per = b.querySelector('[data-lit-pack-per]');
        var sv = b.querySelector('[data-lit-pack-save]');
        if (pe) pe.textContent = money(p);
        if (per) per.textContent = units > 1 ? (L.perUnit || '').replace('[price]', money(p / units)) : (units === 1 ? (L.single || '') : '');
        if (sv) {
          var full = (cfg.singleCents || 0) * units;
          var pct = full > p ? Math.round((1 - p / full) * 100) : 0;
          sv.textContent = pct > 0 ? (L.save || '').replace('[pct]', pct) : '';
        }
      });
      if (subBadge) {
        var a2 = null; state.plan && (function () { var s = state.sub; state.sub = true; a2 = alloc(v); state.sub = s; })();
        var pct2 = a2 && v.price > a2.price ? Math.round((1 - a2.price / v.price) * 100) : 0;
        subBadge.hidden = !pct2;
        subBadge.textContent = pct2 ? (L.subBadge || '').replace('[pct]', pct2) : '';
      }
      if (cadBox) cadBox.hidden = !state.sub;
      var price = priceOf(v);
      document.querySelectorAll('[data-lit-cta-label]').forEach(function (s) {
        s.textContent = v.available ? (L.cta + ' · ' + money(price)) : L.soldOut;
      });
      var sp = document.querySelector('[data-lit-sticky-price]');
      if (sp) sp.textContent = money(price);
      document.querySelectorAll('[data-lit-submit]').forEach(function (b) {
        b.disabled = !v.available;
        if (b.classList.contains('lit-sticky__cta')) b.textContent = v.available ? L.cta : L.soldOut;
      });
      if (cta) { cta.disabled = !v.available; if (v.available) cta.removeAttribute('aria-disabled'); }
    }

    function pickVariant(id) {
      state.vid = id;
      var v = variant(id);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
      if (v && v.featured_media) showMedia(v.featured_media.id);
      render();
    }

    packs.forEach(function (b, i) {
      b.addEventListener('click', function () { setRadio(packs, b); pickVariant(Number(b.dataset.variant)); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % packs.length;
        if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + packs.length) % packs.length;
        if (j > -1) { e.preventDefault(); packs[j].focus(); packs[j].click(); }
      });
    });
    modes.forEach(function (b) {
      b.addEventListener('click', function () { setRadio(modes, b); state.sub = b.dataset.mode === 'sub'; render(); });
    });
    cads.forEach(function (b) {
      b.addEventListener('click', function () { setRadio(cads, b); state.plan = Number(b.dataset.plan); render(); });
    });

    /* only send our own selling_plan (blocks app widgets injecting one) */
    if (form) {
      form.addEventListener('formdata', function (e) {
        var v = variant(state.vid), a = alloc(v);
        e.formData.delete('selling_plan');
        if (state.sub && a) e.formData.set('selling_plan', state.plan);
        if (v) e.formData.set('id', v.id);
      });
    }
    if (cta) document.querySelectorAll('[data-lit-submit]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cta || cta.disabled) return;
        cta.click();
      });
    });

    var main = root.querySelector('[data-lit-main]');
    var thumbs = [].slice.call(root.querySelectorAll('.lit-gal__thumb'));
    function showThumb(t) {
      if (!t || !main) return;
      main.src = t.dataset.src;
      main.srcset = t.dataset.srcset;
      var im = t.querySelector('img');
      thumbs.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      if (im && im.alt) main.alt = im.alt;
    }
    function showMedia(mid) { for (var i = 0; i < thumbs.length; i++) if (Number(thumbs[i].dataset.mediaId) === mid) return showThumb(thumbs[i]); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showThumb(t); }); });

    root.querySelectorAll('[data-lit-tabs]').forEach(function (box) {
      var btns = [].slice.call(box.querySelectorAll('[data-tab]'));
      var panels = [].slice.call(box.querySelectorAll('[data-panel]'));
      var track = box.querySelector('[data-track]');
      function go(i) {
        btns.forEach(function (b) { var on = Number(b.dataset.tab) === i; b.classList.toggle('is-on', on); if (b.hasAttribute('aria-selected')) b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        if (track) track.style.transform = 'translateX(-' + (i * 100) + '%)';
        else panels.forEach(function (p) { p.hidden = Number(p.dataset.panel) !== i; });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { go(Number(b.dataset.tab)); }); });
      if (track) {
        var x0 = null;
        track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        track.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) < 40) return;
          var cur = 0; btns.forEach(function (b) { if (b.classList.contains('is-on')) cur = Number(b.dataset.tab); });
          var n = panels.length; go(Math.max(0, Math.min(n - 1, cur + (dx < 0 ? 1 : -1))));
        }, { passive: true });
      }
    });

    root.querySelectorAll('[data-acc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        var acc = b.closest('.lit-acc');
        acc.querySelectorAll('[data-acc]').forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          o.querySelector('.lit-acc__sign').textContent = '+';
          var body = document.getElementById(o.getAttribute('aria-controls')); if (body) body.hidden = true;
        });
        if (!open) {
          b.setAttribute('aria-expanded', 'true');
          b.querySelector('.lit-acc__sign').textContent = '–';
          var body = document.getElementById(b.getAttribute('aria-controls')); if (body) body.hidden = false;
        }
      });
    });

    var sticky = root.querySelector('[data-lit-sticky]');
    if (sticky && cta) {
      var sbtn = sticky.querySelector('button'), shown = null, tick = false;
      var check = function () {
        tick = false;
        var r = cta.getBoundingClientRect();
        var show = r.bottom < 0 || r.top > window.innerHeight;
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sbtn) sbtn.tabIndex = show ? 0 : -1;
      };
      var onScroll = function () { if (!tick) { tick = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      check();
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-lit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-lit]'); if (r) { r.__lit = false; init(r); } });
})();
